import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { AdvertisementIcon } from "../../../assets/icons/advertisement-icons";
import AddPlaceHolder from "../../../assets/images/add-image.png";

const AdvertisementCard = {
  actionContent: "Wear Your Pride",
  actionDescription: "Get the latest merchandise and represent your team wherever you go. Limited stock available.",
  actionLink: "https://www.google.com",
  image: AddPlaceHolder,
};

const AdCard = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        width: "100%",
        height: "fit-content",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "240px",
          objectFit: "cover",
        }}
        component="img"
        src={AdvertisementCard.image}
        alt="advertisement-card"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "20px 16px",
          height: "fit-content",
          background: "#000",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <a
            // href={AdvertisementCard.actionLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "none !important",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              textDecoration: "none",
              color: "var(--White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 750,
              lineHeight: "normal",
            }}
          >
            {AdvertisementCard.actionContent}
            <AdvertisementIcon
              sx={{
                transform: isArabic ? "scaleX(-1)" : "none",
              }}
            />
          </a>
          <Typography
            sx={{
              color: "var(--White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "18px",
            }}
          >
            {AdvertisementCard.actionDescription}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AdCard;
